var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "send_list", "label-width": "auto" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-control",
                  attrs: {
                    filterable: "",
                    clearable: "",
                    remote: "",
                    placeholder: "Search Group",
                    "remote-method": _vm.search,
                    loading: _vm.loading,
                    popperClass: "custom-popper",
                  },
                  on: { input: _vm.onInput },
                  model: {
                    value: _vm.form.send_list,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "send_list", $$v)
                    },
                    expression: "form.send_list",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: _vm.format(item), value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-purple px-4 mt-5",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.importToSendList.apply(null, arguments)
                },
              },
            },
            [_vm._v("Import")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }